import React, { useState, useMemo, useEffect } from "react";
import {
	Typography,
	Card,
	CardContent,
	Grid,
	Button,
	TextField,
	MenuItem,
	InputAdornment,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Box,
	Paper
} from "@mui/material";
import { Search } from "@mui/icons-material";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from "react-router-dom";
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import HomeIcon from '@mui/icons-material/Home';
import { Breadcrumbs, Link } from "@mui/material";
import axios from "axios";
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import ModalNotificacao from "./ModalNotificacao";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import { gerarLinkWhatsApp } from "../../../utils/WhatsappLink";

const statusMap = {
	PENDING: { label: "Pendente", colorBg: "#fff8e1", colorText: "#f9a825" },
	RECEIVED: { label: "Pago", colorBg: "#e8f5e9", colorText: "#2e7d32" },
	RECEIVED_IN_CASH: { label: "Pago", colorBg: "#e8f5e9", colorText: "#2e7d32" },
	CONFIRMED: { label: "Pago", colorBg: "#e8f5e9", colorText: "#2e7d32" },
	OVERDUE: { label: "Vencida", colorBg: "#ffebee", colorText: "#c62828" },
	DUNNING_REQUESTED: { label: "Vencida", colorBg: "#ffebee", colorText: "#c62828" },
	DUNNING_RECEIVED: { label: "Vencida", colorBg: "#ffebee", colorText: "#c62828" },
	REFUNDED: { label: "Reembolsada", colorBg: "#e1f5fe", colorText: "#0277bd" },
	REFUND_REQUESTED: { label: "Reembolso solicitado", colorBg: "#e1f5fe", colorText: "#0277bd" },
	REFUND_IN_PROGRESS: { label: "Reembolso em progresso", colorBg: "#e1f5fe", colorText: "#0277bd" },
	CHARGEBACK_REQUESTED: { label: "Chargeback", colorBg: "#fce4ec", colorText: "#c2185b" },
	CHARGEBACK_DISPUTE: { label: "Chargeback", colorBg: "#fce4ec", colorText: "#c2185b" },
	AWAITING_CHARGEBACK_REVERSAL: { label: "Chargeback", colorBg: "#fce4ec", colorText: "#c2185b" },
	AWAITING_RISK_ANALYSIS: { label: "Análise de risco", colorBg: "#fff3e0", colorText: "#ef6c00" },
	// Outros status podem ser adicionados aqui conforme necessário
};

const statusOptions = [
	{ value: "todos", label: "Todos" },
	{ value: "Pendente", label: "Pendentes" },
	{ value: "Pago", label: "Pagas" },
	{ value: "Vencida", label: "Vencidas" },
	{ value: "Reembolsada", label: "Reembolsadas" },
	{ value: "Chargeback", label: "Chargebacks" },
	{ value: "Análise de risco", label: "Análise de risco" },
];

const FaturasPendentes = () => {
	const { user } = useUser();
	console.log(user)
	const navigate = useNavigate();

	const [busca, setBusca] = useState("");
	const [statusFiltro, setStatusFiltro] = useState("todos");
	const [faturas, setFaturas] = useState([]);
	const [userActive, setUserActive] = useState(true);
	const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
	const [notificacoes, setNotificacoes] = useState([]);

	useEffect(() => {
		// Verifica se o usuário está com fatura vencida
		const hasFaturasVencidas = user?.faturas?.vencidas?.length > 0;

		if (hasFaturasVencidas) {
			setUserActive(false);
		} else {
			setUserActive(true);
		}
	}, [user]);

	useEffect(() => {
		const getNotify = async () => {
			const response = await axios.post(`${process.env.REACT_APP_API_URL}/buscarNotificacoes`, { email: localStorage.getItem("email") }, {
				headers: {
					Authorization: `${localStorage.getItem("token")}`
				}
			});

			if (response.data.status === 200) {
				setNotificacoes(response.data.notificacoes)
			}
		}

		getNotify();
	}, [])


	function formatarDataBR(dataISO) {
		if (!dataISO) return "";
		const [ano, mes, dia] = dataISO.split("-");
		return `${dia}/${mes}/${ano}`;
	}

	useEffect(() => {
		if (!user || !user.faturas) return;

		// Supondo que user.faturas seja um objeto com arrays agrupados ou um array com todas faturas
		// Se for um array só com todas faturas, descomente a próxima linha e comente as outras:
		// const todasFaturas = user.faturas;

		// Exemplo: se você armazenar agrupado, combine arrays:
		const todasFaturas = [
			...(user.faturas.pendentes || []),
			...(user.faturas.vencidas || []),
		];

		const faturasFormatadas = todasFaturas.map((fatura, index) => {
			const statusInfo = statusMap[fatura.status] || { label: fatura.status, colorBg: "#eee", colorText: "#333" };

			return {
				id: index + 1,
				numero: fatura.nossoNumero || `FAT-${index + 1}`,
				vencimento: formatarDataBR(fatura.dueDate) || "—",
				valor: fatura.value || 0,
				status: statusInfo.label,
				bankSlipUrl: fatura.bankSlipUrl || "#",
				colorBg: statusInfo.colorBg,
				colorText: statusInfo.colorText,
				billingType: fatura.billingType || "—",
			};
		});

		setFaturas(faturasFormatadas);
	}, [user]);

	const linhasFiltradas = useMemo(() => {
		return faturas
			.filter(f => statusFiltro === "todos" || f.status === statusFiltro)
			.filter(f => f.numero?.toLowerCase().includes(busca.toLowerCase()));
	}, [faturas, statusFiltro, busca]);

	const formatarData = (data) => {
		return new Intl.DateTimeFormat("en-US", {
			day: "2-digit",
			month: "short",
			year: "numeric",
			timeZone: "UTC",
		}).format(new Date(data));
	};


	return (
		<>
			<HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
			<div style={{ padding: "30px", background: "#f4f6f8", minHeight: "100vh", marginTop: "64px" }}>
				<div style={{ width: "100%", height: "fit-content", padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
					<div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
						<div style={{ width: "80%" }}>
							<Breadcrumbs aria-label="breadcrumb">
								<Link
									underline="hover"
									sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
									color="inherit"
									onClick={() => navigate("../Dashboard")}
								>
									<HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
									Dashboard
								</Link>
								<Typography
									sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
								>
									<HourglassBottomIcon sx={{ mr: 0.5 }} fontSize="inherit" />
									Faturas Pendentes
								</Typography>
							</Breadcrumbs>
						</div>
					</div>
				</div>
				<Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
					<Box sx={{ width: { xs: "90%", md: "80%" }, borderRadius: "8px" }}>
						<Typography
							variant="h4"
							sx={{ fontWeight: 700, mb: 3 }}
						>
							Faturas em Aberto
						</Typography>
					</Box>
				</Box>
				<div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
					<div style={{ width: window.innerWidth > 768 ? "80%" : "100%", display: "flex", justifyContent: "flex-start", marginBottom: "10px", gap: 10, flexWrap: "wrap" }}>
						<div style={{ width: window.innerWidth > 768 ? "280px" : "100%", height: "150px", backgroundColor: "#fff", borderRadius: "8px", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 2, padding: "20px", borderLeft: "4px solid #c62828" }}>
							<span style={{ display: "flex", flexDirection: "column", gap: 1, fontSize: "12px", fontWeight: 500 }}>
								TOTAL EM ABERTO
							</span>
							<span style={{ fontSize: "44px", fontWeight: 700, color: "#c62828" }}>
								R$ {faturas.reduce((total, f) => total + (f.status === "Pendente" || f.status === "Vencida" ? f.valor : 0), 0).toFixed(2).replace(".", ",")}
							</span>
							<span style={{ display: "flex", alignItems: "center", gap: 1, fontSize: "12px", fontWeight: 500 }}>
								<AccessTimeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
								{faturas.filter(f => f.status === "Pendente" || f.status === "Vencida").length} {faturas.filter(f => f.status === "Pendente" || f.status === "Vencida").length === 1 ? "fatura" : "faturas"} pendente{faturas.filter(f => f.status === "Pendente" || f.status === "Vencida").length !== 1 && "s"}
							</span>
						</div>

						<div style={{ width: window.innerWidth > 768 ? "280px" : "100%", height: "150px", backgroundColor: "#fff", borderRadius: "8px", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 2, padding: "20px", borderLeft: "4px solid #901CB3" }}>
							<span style={{ display: "flex", flexDirection: "column", gap: 1, fontSize: "12px", fontWeight: 500 }}>
								PRÓXIMO VENCIMENTO
							</span>
							<span style={{ fontSize: "34px", fontWeight: 700 }}>
								{user?.assinatura?.proximaCobranca ? formatarData(user.assinatura.proximaCobranca) : "..."}
							</span>
							<span style={{ display: "flex", alignItems: "center", gap: 1, fontSize: "12px", fontWeight: 500 }}>
								<AccessTimeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
								Ciclo plano {user?.plano?.nome || "..."}
							</span>
						</div>
					</div>
				</div>
				<div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
					<div style={{ width: window.innerWidth > 768 ? "80%" : "100%", display: "flex", justifyContent: "space-between", gap: 15, flexWrap: "wrap" }}>
						<div style={{ width: "70%", minWidth: window.innerWidth > 768 ? "280px" : "100%" }}>
							<TableContainer component={Paper} sx={{ borderRadius: "12px" }}>
								<Table>
									<TableHead>
										<TableRow>
											<TableCell><strong>Nº Fatura</strong></TableCell>
											<TableCell><strong>Plano</strong></TableCell>
											<TableCell><strong>Vencimento</strong></TableCell>
											<TableCell><strong>Valor</strong></TableCell>
											<TableCell><strong>Status</strong></TableCell>
											<TableCell align="center"><strong>Ação</strong></TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{linhasFiltradas.length > 0 ? (
											linhasFiltradas.map((fatura) => (
												<TableRow key={fatura.id}>
													<TableCell>{fatura.numero}</TableCell>
													<TableCell sx={{ color: "#901CB3", fontWeight: 700 }}>{user.plano?.nome || "—"}</TableCell>
													<TableCell sx={{ width: "150px", color: fatura.status === "Vencida" ? "#d32f2f" : "#000" }}>{fatura.vencimento} (Atrasada {new Date().getDate() - new Date(fatura.vencimento).getDate()} dias)</TableCell>
													<TableCell>
														R$ {Number(fatura.valor).toFixed(2).replace(".", ",")}
													</TableCell>
													<TableCell>
														<span
															style={{
																padding: "4px 10px",
																borderRadius: "12px",
																backgroundColor: fatura.colorBg,
																color: fatura.colorText,
																fontWeight: 600,
																fontSize: "0.8rem"
															}}
														>
															{fatura.status.toUpperCase()}
														</span>
													</TableCell>
													<TableCell align="center">
														<Button
															variant="contained"
															size="small"
															sx={{
																backgroundColor: "#d32f2f",
																display: fatura?.billingType === "CREDIT_CARD" ? "none" : "inline-flex",
																color: "#fff",
																textTransform: "none",
																'&:hover': { backgroundColor: "#b71c1c" }
															}}
															onClick={() => window.open(fatura.bankSlipUrl, "_blank")}
															disabled={["Pago", "Reembolsada", "Reembolso solicitado", "Reembolso em progresso", "Chargeback", "Chargeback", "Chargeback", "Análise de risco"].includes(fatura.status)}
														>
															pagar
														</Button>
													</TableCell>
												</TableRow>
											))
										) : (
											<TableRow>
												<TableCell colSpan={6} align="center">
													Nenhuma fatura encontrada.
												</TableCell>
											</TableRow>
										)}
									</TableBody>
								</Table>
							</TableContainer>
						</div>
						<div style={{ width: window.innerWidth > 768 ? "28%" : "100%", minWidth: window.innerWidth > 768 ? "300px" : "100%", display: "flex", flexDirection: "column", gap: 2 }}>
							<Box
								sx={{
									width: "100%",
									height: "300px",
									backgroundColor: "#EFEFEF",
									borderRadius: "14px",
									p: "20px",
									display: "flex",
									flexDirection: "column",
									justifyContent: "space-between",
									border: "1px solid #DCDCDC",
									boxSizing: "border-box",
								}}
							>
								{/* Cabeçalho */}
								<Box sx={{ display: "flex", gap: 2 }}>
									<Box
										sx={{
											width: "38px",
											height: "38px",
											borderRadius: "10px",
											background: "#FFF",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											flexShrink: 0,
										}}
									>
										<HeadsetMicOutlinedIcon
											sx={{
												fontSize: "18px",
												color: "#A020F0",
											}}
										/>
									</Box>

									<Box>
										<Typography
											sx={{
												fontSize: "24px",
												fontWeight: 700,
												lineHeight: 1.1,
												color: "#111",
											}}
										>
											Precisa de Ajuda?
										</Typography>

										<Typography
											sx={{
												fontSize: "15px",
												color: "#666",
												mt: 0.5,
												lineHeight: 1.4,
											}}
										>
											Problemas com faturamento ou notas fiscais.
										</Typography>
									</Box>
								</Box>

								{/* Texto central */}
								<Typography
									sx={{
										fontSize: "16px",
										color: "#555",
										lineHeight: 1.5,
									}}
								>
									Se você acredita que houve um erro em sua cobrança ou deseja alterar alguma informação, fale conosco.
								</Typography>

								{/* Botão */}
								<Button
									variant="outlined"
									endIcon={<OpenInNewOutlinedIcon />}
									sx={{
										height: "48px",
										borderRadius: "8px",
										borderColor: "#A020F0",
										color: "#A020F0",
										textTransform: "none",
										fontWeight: 700,
										fontSize: "15px",
										"&:hover": {
											borderColor: "#8B00E0",
											backgroundColor: "rgba(160,32,240,0.04)",
										},
									}}
									onClick={() => window.open(gerarLinkWhatsApp("Olá, estou com problemas com faturamento ou notas fiscais."), "_blank")}
								>
									Falar com Suporte
								</Button>
							</Box>
						</div>
					</div>
				</div>
			</div>
			<ModalNotificacao
				openModalNotificacao={openModalNotificacao}
				onClose={() => setOpenModalNotificacao(false)}
				notificacoes={notificacoes}
			/>
		</>
	);
};

export default FaturasPendentes;
